module.exports = __webpack_public_path__ + "73c6f4a7ed9799ec1d8d668f7d27eccf.pdf";